import { graphql } from "gatsby"
import React from "react"

export const RichTextArea = (props: any) => {
    return (
        <div
            className="rich-text-area-module relative max-w-screen-md my-3 mx-auto"
            dangerouslySetInnerHTML={{ __html: props.html ?? "" }}
        />
    )
}

export default RichTextArea

export const query = graphql`
fragment DrupalRichTextAreaContent on DrupalRichTextArea {
  id
  html
}
`